import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f8c2fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "m-web-component"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ad-msg" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" App内打开 ")

import {bindElement, openOrDownloadAppNew} from '@gaotu/open-app-sdk';
import {Button} from 'vant';
import {computed, onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import CloseSvg from '@/assets/img/close.svg';
import gaotuLogo from '@/assets/img/gaotuLogo.png';
import gongkaoLogo from '@/assets/img/gongkaoLogo.png';
import tutuLogo from '@/assets/img/tutuLogo.png';
import jingpinLogo from '@/assets/img/jingpinLogo.png';
import xinliLogo from '@/assets/img/xinliLogo.png';
import ketangLogo from '@/assets/img/ketangLogo.png';
import useUa from '@/hooks/useUa';
import {getUrlSearch} from '@/utils/getUrlSearch';
import {haboClickReport} from '@/plugins/haboConfig';


const __default__ = {
  name: 'MWebComponent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {outOpenParams} = useUa();
const mWebConfig = {
  gaotu: {
    logo: gaotuLogo,
    appName: '高途',
    description: '打开APP, 操作流畅学习更高效',
    btnText: '打开',
  },
  gongkao: {
    logo: gongkaoLogo,
    appName: '高途公考',
    description: '打开APP, 查看更多岗位',
    btnText: '去看看',
  },
  tutu: {
    logo: tutuLogo,
    appName: '途途课堂',
    description: '打开APP, 查看更多资讯信息',
    btnText: '打开'
  },
  jingpin: {
    logo: jingpinLogo,
    appName: '高途高中规划',
    description: '打开APP, 操作流程学习更高效',
    btnText: '打开'
  },
  xinli: {
    logo: xinliLogo,
    appName: '高途心理',
    description: '打开APP, 查看更多资讯信息',
    btnText: '打开'
  },
  ketang: {
    logo: ketangLogo,
    appName: '高途课堂',
    description: '打开APP, 查看更多资讯信息',
    btnText: '打开'
  },
};

const isBarShow = ref<boolean>(true);
// 关闭组件
const handleCloseBar = () => {
  isBarShow.value = false;
};
const router = useRouter();
const infoId = ref<number>(+router.currentRoute.value.params.infoId as number);

const shareUrl = computed(() => {
  const {cmsCode, contentCode} = getUrlSearch();
  const queryStr = `cmsCode=${cmsCode}&contentCode=${contentCode}&showNavigationBar=0&showStatusBar=0&previewSource=1`;
  return `${window.location.origin}${window.location.pathname}?${queryStr}`;
});
const open = ref<any>(null);
const fix = ref<any>(null);
onMounted(() => {
  const {fromWeChat} = getUrlSearch();
  // 如果是微信开放标签跳转失败跳转过来的, 就直接尝试打开 App
  haboClickReport('INFO_H5_BANNER_SHOW', {position: 1, news_id: infoId.value});
  if (fromWeChat) {
    openOrDownloadAppNew({
      link: shareUrl.value,
      category: 'web',
      noah: 1,
    });
  }
  bindElement(open.value.$el, {
    link: shareUrl.value,
    category: 'web',
    noah: 1,
  });
  bindElement(fix.value.$el, {
    link: shareUrl.value,
    category: 'web',
    noah: 1,
  });
});
const openClick = (position: number) => {
  console.log(infoId.value);
  haboClickReport('INFO_H5_BANNER_CLICK', {position, news_id: infoId.value});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isBarShow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _unref(CloseSvg),
            class: "close-icon",
            alt: "",
            onClick: handleCloseBar
          }, null, 8, _hoisted_2),
          _createElementVNode("img", {
            src: mWebConfig[_unref(outOpenParams).app].logo,
            class: "logo-icon",
            alt: ""
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(mWebConfig[_unref(outOpenParams).app].appName), 1),
            _createElementVNode("p", null, _toDisplayString(mWebConfig[_unref(outOpenParams).app].description), 1)
          ]),
          _createVNode(_unref(Button), {
            ref_key: "open",
            ref: open,
            class: "open-app-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openClick(1)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(mWebConfig[_unref(outOpenParams).app].btnText), 1)
            ]),
            _: 1
          }, 512)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(Button), {
      ref_key: "fix",
      ref: fix,
      class: "fix-btn",
      type: "primary",
      round: "",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (openClick(2)))
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})